import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';

import { useIsFulfillmentVoided } from '../../../../../../../hooks/entities/selectors/fulfillments';
import { undoMarkAsShippedFromOrderDetails } from '../../../../../../../store/mark-as-shipped/mark-as-shipped.actions';
import messages from '../../../../../rate-card/read-only/label-actions/messages';

const UndoMarkAsShippedMenuItem = ({ fulfillmentId }) => {
  const dispatch = useDispatch();

  const undoMarkAsShipped = useCallback(() => {
    dispatch(undoMarkAsShippedFromOrderDetails(fulfillmentId));
  }, [dispatch, fulfillmentId]);

  const isDisabled = useIsFulfillmentVoided(fulfillmentId);
  return (
    <DropdownMenuItem disabled={isDisabled} onClick={undoMarkAsShipped}>
      <FormattedMessage {...messages.undoMarkAsShipped} />
    </DropdownMenuItem>
  );
};

export { UndoMarkAsShippedMenuItem };

UndoMarkAsShippedMenuItem.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};
